module.exports = __webpack_public_path__ + "img/nike_logo.aa8b6b9d.jpg";